import React from 'react';
import styles from "./styles.module.css";
import Header from '../header'
import Footer from '../footer'

const Contato: React.FC = (props) => {

    return (
        <div>
            <div className={styles.containermenu}>
                <Header />
            </div>
            <div className={styles.container}>


            <h1>QUEM SOMOS? NANDA CONFEITOS</h1>
            <h2>Nanda confeitos, guloseimas feitas com carinho para satisfazer seus doces desejos.</h2>

            <p>Confeitaria em geral, bolos, doces, tortas, guloseimas e mimos mais que gostosos para alegrar o seu dia e a sua barriga.</p>
            <p>Aqui na NANDA CONFEITOS, tudo é feito com muito carinho e caprixo, para que você consumidor fique satisfeito.</p>

            </div>
            <Footer/>
        </div>

    )

}

export default Contato;